module.exports = __webpack_public_path__ + "img/jmg.84071454.png";